import { updateMapData } from '@bpd-library/components';
import {
    getFilteredData,
    getSoldProjectsData,
    updateView,
    ViewData,
} from '@features/properties/store';
import { hasConsent } from '@store/service-consent';
import getExtendedAreaMapData from '@utilities/api-utilities/get-extended-area-map-data';
import { RouteHandler } from '@utilities/hooks/use-routing';

import { usePropertiesRouting } from '../hooks/use-properties-routing';
import { setPropertiesMapBounds } from '../utilities/bounding-box';
import { getSoldProjectPhaseMapData } from '../utilities/sold-project-phase-data';

const propertyTypeRoute: RouteHandler = ({ slug, viewId }) => {
    const { setRoute } = usePropertiesRouting();
    const viewData: ViewData = [];

    let data = getFilteredData();
    const isSoldData = data?.projectPhases.every((project) => project.status === 'Sold');

    if (data && data.projectPhases.length && !isSoldData) {
        viewData.push(
            ...data.propertyTypes.filter(({ apartmentBuildings }) => !apartmentBuildings?.length),
            ...data.apartmentBuildings,
        );
    } else {
        data = getSoldProjectsData();
        if (!data || !data.projectPhases.length) return;
        viewData.push(...data.projectPhases.filter(({ mainImage }) => !!mainImage?.url));
    }

    updateView({
        type: 'propertyType',
        data: viewData,
        dataType: isSoldData ? 'soldProjects' : 'default',
        viewId,
        slug,
        onCardClick(e, item, cardType) {
            if (item.constructionNumbers?.length) {
                e.preventDefault();
                e.stopPropagation();

                if (cardType === 'apartmentBuilding') {
                    setRoute({
                        to: 'apartmentView',
                        slug: item.id,
                    });
                }
                if (cardType === 'propertyType' || cardType === 'projectPhase') {
                    setRoute({
                        to: 'constructionNumber',
                        slug: item.id,
                    });
                }

                return;
            }

            if (cardType === 'apartmentBuilding') {
                setRoute({
                    to: 'apartmentView',
                    slug: item.id,
                });
            }
        },
    });

    if (hasConsent('mapbox')) {
        const mapData = getExtendedAreaMapData(data);
        const soldProjectPolygons = getSoldProjectPhaseMapData();

        updateMapData([...mapData, ...soldProjectPolygons]);
        setPropertiesMapBounds(data, mapData);
    }
};

export { propertyTypeRoute };
